// styled components
import { ThemeProvider as StyledThemeProvider } from "styled-components"

// material ui
import { ThemeProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"

// redux
// import { useIsAuthorizedQuery } from "../app/auth/auth-slice"
import { RouterProvider } from "react-router-dom"
import { router } from "./router"

const { materialTheme } = require("./material-theme")

// interface AppProps {
//   data: any
//   isFetching: boolean
// }

function App() {
  // const { data: user, isFetching } = useIsAuthorizedQuery<AppProps>({})

  let theme
  // if (user && !isFetching) {
  //   localStorage.setItem("mode", user.profileTheme || "light")
  //   theme = createTheme(materialTheme({ profileTheme: user.profileTheme }))
  // }

  localStorage.setItem("mode", "light")
  theme = createTheme(materialTheme({ profileTheme: "light" }))

  return (
    <>
      {theme ? (
        <StyledThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} fallbackElement={<>Loading...</>} />
          </ThemeProvider>
        </StyledThemeProvider>
      ) : null}
    </>
  )
}

export default App
